// Focus session durations and energy earned
export const FOCUS_DURATIONS = {
  25: 5,   // 25 min = 5 energy
  50: 10,  // 50 min = 10 energy
  90: 18,  // 90 min = 18 energy
} as const

export type FocusDuration = keyof typeof FOCUS_DURATIONS

// Energy system
export const MAX_WINDOW_ENERGY = 24
export const WINDOW_HOURS = 2
export const GRACE_PERIOD_MINUTES = 5
export const ENERGY_INTERVAL_MINUTES = 5  // Pro-rate energy at 5-minute intervals

// Travel
export const TRAVEL_COST = 5
export const TRAVEL_TIME_MINUTES = 4

// Rarity colors
export const RARITY_COLORS = {
  common: '#94a3b8',
  uncommon: '#22c55e',
  rare: '#3b82f6',
  'very-rare': '#a855f7',
  mythic: '#f59e0b',
} as const

export type Rarity = keyof typeof RARITY_COLORS
